var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 4H12.0001C11.0535 4 10.2861 4.76738 10.2861 5.714V5.715C10.2861 6.66162 11.0535 7.429 12.0001 7.429H12.0011C12.9477 7.429 13.7151 6.66162 13.7151 5.715V5.714C13.7151 4.76738 12.9477 4 12.0011 4Z",
    fill: "#596975"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 10.286H12.0001C11.0535 10.286 10.2861 11.0534 10.2861 12V12.001C10.2861 12.9476 11.0535 13.715 12.0001 13.715H12.0011C12.9477 13.715 13.7151 12.9476 13.7151 12.001V12C13.7151 11.0534 12.9477 10.286 12.0011 10.286Z",
    fill: "#596975"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 16.571H12.0001C11.0535 16.571 10.2861 17.3384 10.2861 18.285V18.286C10.2861 19.2326 11.0535 20 12.0001 20H12.0011C12.9477 20 13.7151 19.2326 13.7151 18.286V18.285C13.7151 17.3384 12.9477 16.571 12.0011 16.571Z",
    fill: "#596975"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVertical);
export default __webpack_public_path__ + "static/media/menu_vertical.ab02478a.svg";
export { ForwardRef as ReactComponent };